import { Loader } from '@googlemaps/js-api-loader';

// The API key is supplied by the page markup rather than being hardcoded in
// the bundle, so environments can use their own keys. The backend must render
// either of:
//   <meta name="google-maps-api-key" content="...">
//   <script>window.LTA_GOOGLE_MAPS_API_KEY = '...';</script>
const getApiKey = () =>
	window.LTA_GOOGLE_MAPS_API_KEY || document.querySelector('meta[name="google-maps-api-key"]')?.content || '';

let loader;

// Single shared Loader so the Maps JavaScript API is only requested when a
// component actually needs it. The Loader is a singleton and throws if
// re-created with different options, so every component must obtain it from
// here instead of calling `new Loader()` itself.
const getLoader = () => {
	if (!loader) {
		const apiKey = getApiKey();
		if (!apiKey) {
			// eslint-disable-next-line no-console
			console.error(
				'Google Maps API key is missing. Add a <meta name="google-maps-api-key"> tag or set window.LTA_GOOGLE_MAPS_API_KEY before loading maps.'
			);
		}
		loader = new Loader({
			apiKey,
			version: 'weekly',
			libraries: []
		});
	}
	return loader;
};

/**
 * Resolves once the core Maps JavaScript API is available on window.google.
 *
 * @returns {Promise} - Resolves with the google namespace
 */
export const loadGoogleMaps = () => getLoader().load();

/**
 * Loads the Places library on demand, without billing pages that never use it.
 *
 * @returns {Promise} - Resolves with the Places library (Autocomplete etc.)
 */
export const loadPlacesLibrary = () => getLoader().importLibrary('places');
